<!--
 * @Author: zhangxx 2425792130@qq.com
 * @Date: 2025-07-29 19:12:26
 * @LastEditors: zhangxx 2425792130@qq.com
 * @LastEditTime: 2025-07-31 18:23:56
 * @FilePath: \original-pc-toB-bookstores-red(ToB书城PC版红色)\src\views\readHome\readingHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="ReadingClassify">
        <div class="topbg">
            <h1 class="header-title">分类</h1>
        </div>
        <div class="ereas">
            <div class="left">
                <AccordionComponent
                  :initial-data="initialData"
                  @toggle="handleToggle"
                  @content-click="handleContentClick"
                />
            </div>
            <div class="right">
                <div class="type">
                    <div class="book-type-container">
                        <div 
                            class="voice" 
                            :class="{'voiceActive': statusType   === '' || statusType   === 'eBook' }"
                            v-for="item in bookTypes" 
                            v-if="(statusType===''&& item.key==='Book')||(item.key==='Book')"
                            @click="handleTypeChange(item.key)"
                            :aria-pressed="statusType === item.key"
                            type="button"
                        >
                            <span v-if="item.key==='Book'">电子书</span>
                            <span v-if="item.key==='AudioBook'">有声书</span>
                            <span v-if="item.key==='Course'">课程</span>({{ item.doc_count }})
                        </div>
                        <div 
                            class="voice" 
                            :class="{'voiceActive': statusType  === item.key}"
                            v-for="item in bookTypes" 
                            v-if="item.key != 'Book'"
                            @click="handleTypeChange(item.key)"
                            :aria-pressed="statusType === item.key"
                            type="button"
                        >
                            <span v-if="item.key==='Book'">电子书</span>
                            <span v-if="item.key==='AudioBook'">有声书</span>
                            <span v-if="item.key==='Course'">课程</span>({{ item.doc_count }})
                        </div>
                    </div>
                    <div>
                        <button 
                            :class="['filter-button', { 'active': activeFilter === 'new' }]"
                            @click="setActiveFilter('new')"
                        >
                            最新
                        </button>
                        <button 
                            :class="['filter-button', { 'active': activeFilter === 'hot' }]"
                            @click="setActiveFilter('hot')"
                        >
                            最热
                        </button>
                    </div>
                </div>
                <div class="book" >
                    <div class="book-item" v-for="item in classifyData.list" :key="item.id">
                        <div class="lefts" @click="setupBackRouterPath(item)">
                            <img :src="prefix + 'ui/draftBook/getCover?multimediaID=' + item.source.logoID||item.source.ID" alt="" @error="handleError" v-if="item.indexType == 'Book' || item.indexType == null">
                            <img v-else :src="item.source.imgUrlCompressed" alt="" @error="handleError" >
                        </div>
                        <div class="right">
                            <h4 class="title" @click="setupBackRouterPath(item)">{{ item.source.title }}</h4>
                            <p>{{ item.source.authors }}</p>
                            <div class="desc" v-html="item.source.summary" v-if="item.source.summary"></div>
                            <div class="desc"  v-else>暂无</div>
                        </div>
                    </div>
                </div>
                <loading-view v-if="classifyData.loading" />
                <!-- 无更多数据提示 -->
                 <div v-if="classifyData.list.length  === 0" class="no-data">
                    暂无数据
                </div>
                <div v-if="noMore && classifyData.list&& classifyData.list.length > 0" class="no-more">
                    已加载全部数据
                </div>
            </div>
        </div>
        <BackTop
        :bottom="300"
        :right="backTopRight"
        class="boska"
        :class="
            isShowScrollBtn && isShowScrollBtn2
            ? 'showScrollBtn'
            : 'unShowScrollBtn'
        "
        on-click="scrollToTop()"
        >
        <div class="top" @click="scrollToTop">
            <div class="divg">
            <img
                style="width: 100%; height: 100%"
                src="../../assets/image/shang.png"
                alt=""
            />
            </div>
        </div>
        </BackTop>
    </div>
</template>

<script>
import AccordionComponent from '@/views/components/accorDion.vue';
import api from '@/api/index.js';
import defaultImg2 from '@/assets/readimg/defaultImg2.png'
export default {
    name: 'ReadingClassify',
    components: {
        AccordionComponent
    },
    data() {
        return {
            activeFilter: 'new', // 默认选中"最新"
            prefix: this.prefix,
            statusType: '',
            initialData: [],
            bookTypes: [
                { id: 1, name: '电子书', key: 'eBook', doc_count: 0 },
                { id: 2, name: '有声书', key: 'audioBook', doc_count: 0 },
                { id: 3, name: '课程', key: 'course', doc_count: 0 }
            ],
            token: localStorage.getItem("user_token")||'',
            classifyData:{
                list:[],
                total:0,
                pageIndex: 0,
                pageSize: 10,
                code:'',
                innerCode:'',
                loading:false
            },
            scrollContainer: null,  // 父组件的滚动容器DOM
            scrollDebounce: null,    // 防抖计时器
            finished: false,
            noMore: false, // 是否无更多数据
            isShowScrollBtn: false,
            backTopRight: 200,
            isShowScrollBtn2: false,
        }
    },
    props: {
        parentScrollRef: {  // 父组件传递的滚动容器ref名称
            type: String,
            default: 'main'
        }
    },
    mounted() {
        var that = this;
        window.addEventListener("resize", function () {
            that.css_caculateBackTopRight();
        });
        this.css_caculateBackTopRight();
        this.getClassify();
    },

    methods: {
        css_caculateBackTopRight() {
            var screenWidth = document.body.offsetWidth;
            if (screenWidth < 1200) {
                this.isShowScrollBtn2 = false;
            } else {
                this.isShowScrollBtn2 = true;
            }
            var right = (screenWidth - 1157) / 2 - 30;
            this.backTopRight = right || 200;
        },
         scrollParentToTop() {
            // 1. 获取父组件的滚动容器DOM
            const parentScrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!parentScrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref是否正确');
                return;
            }
            parentScrollContainer.scrollTop = 0;
        },
        async getClassify(){
            this.classifyData.loading = true
            try{
                let res = await api.classifyAgg(this.token)
                if(res.data.status == 1){
                    let data = res.data.data.aggs['xtsflCode']
                     this.initialData = data.map((item, index) => {
                        // 如果存在 children，给每个 child 设置 isActive 为 false
                        if (item.children && Array.isArray(item.children)) {
                            item.children = item.children.map(child => ({
                            ...child,
                            isActive: false
                            }));
                        }

                        return {
                            ...item,
                            isExpanded: index === 0
                        };
                        });

                    this.classifyData.code = this.initialData[0].code
                    this.classifyData.innerCode = this.initialData[0].innerCode
                    this.classifyData.loading = false
                    // 1. 获取父组件的滚动容器（关键步骤）
                    this.getParentScrollContainer();
                    this.getList(this.initialData[0].code,this.initialData[0].innerCode)
                }
                    
            }catch(error){
                this.$message.error(error.message);
            }
        },
        async getList(code,innerCode,tab){
            if (this.classifyData.loading || this.noMore) return;
            this.classifyData.loading = true
            let statusType = ''
            if(this.statusType === 'Book'){
                statusType = 'eBook'
            }else if(this.statusType === 'AudioBook'){
                statusType = 'audioBook'
            }else if(this.statusType === 'Course'){
                statusType = 'course'
            }else{
                statusType = ''
            }
            let params ={
                    pageIndex: this.classifyData.pageIndex,
                    pageSize: this.classifyData.pageSize,
                    type: statusType,
                    status: this.activeFilter,
                    code: code,
                    innerCode: innerCode,
                }
            try{
                let res = await api.classifyList(params,this.token)
                if(res.data.status){
                    this.classifyData.loading = false
                    this.classifyData.list =  [...this.classifyData.list, ...res.data.data.hits] 
                    this.classifyData.total = res.data.data.total
                    if(tab!='tab'){
                        this.bookTypes = res.data.data.aggs?.indexType|| []
                    }
                    // this.updateBookTypesFromApi(res.data.data.aggs?.indexType || []);
                    // 判断是否有更多数据
                    this.noMore = this.classifyData.list.length >= this.classifyData.total;
                    console.log("this.noMore",this.noMore)
                    console.log("this.classifyData.list.length",this.classifyData.list.length)
                    console.log("this.classifyData.total",this.classifyData.total)
                    if (this.classifyData.list.length >= this.classifyData.total || this.classifyData.total < this.classifyData.pageSize) {
                        this.finished = true
                    }
                }
            }catch(error){
                this.$message.error(error.message);
            }

        },
        updateBookTypesFromApi(indexTypeData) {
            // 检查接口数据是否有效
            if (!Array.isArray(indexTypeData) || indexTypeData.length === 0) {
                this.bookTypes = [
                    { id: 1, name: '电子书', key: 'eBook', doc_count: 0 },
                    { id: 2, name: '有声书', key: 'audioBook', doc_count: 0 },
                    { id: 3, name: '课程', key: 'course', doc_count: 0 }
                ]
                return;

            }
            
            // 遍历接口返回的数据
            indexTypeData.forEach(apiItem => {
                // 处理接口 key 与本地 key 的映射关系
                let localKey;
                switch(apiItem.key) {
                    case 'Book':
                        localKey = 'eBook'; // 接口 Book 对应本地 eBook
                        break;
                    case 'AudioBook':
                        localKey = 'audioBook'; // 接口 AudioBook 对应本地 audioBook
                        break;
                    case 'Course':
                        localKey = 'course'; // 接口 Course 对应本地 course
                        break;
                    default:
                        return; // 不匹配的 key 忽略
                }
                
                // 找到本地对应项并更新 doc_count
                const localItem = this.bookTypes.find(item => item.key === localKey);
                if (localItem && localItem.doc_count !== apiItem.doc_count) {
                    localItem.doc_count = apiItem.doc_count;
                }
            });
        },
        handleToggle(data) {
            if(data){
                console.log("data",data)
                this.classifyData.code = data.item.code
                this.classifyData.list = []
                this.noMore = false
                this.classifyData.pageIndex = '0'
                this.getList(this.classifyData.code,data.item.key)
            }else{
                this.scrollParentToTop()
                // debugger
                this.statusType = 'Book'
                // this.classifyData.innerCode = ''
                // this.classifyData.pageIndex = '0'
                // this.getList('','')
            }
            console.log("data",data)
            

        },
        scrollToTop() {
            this.$refs.main.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
        handleContentClick(data) {
            this.scrollParentToTop()
            this.statusType = 'Book'
            this.classifyData.code = data.item.code
            this.classifyData.innerCode = data.child.key
            this.noMore = false
            this.classifyData.list = []
            this.classifyData.pageIndex = '0'
            this.getList(this.classifyData.code,this.classifyData.innerCode)

        },
        
        handleTypeChange(type) {
            this.statusType = type;
            console.log('切换书籍类型:', type);
            this.noMore = false
            this.classifyData.list = []
            this.classifyData.pageIndex = '0'
            this.getList(this.classifyData.code,this.classifyData.innerCode,'tab');
        },
        setActiveFilter(filterType) {
            this.activeFilter = filterType;
            this.noMore = false
            this.classifyData.list = []
            this.classifyData.pageIndex = '0'
            this.getList(this.classifyData.code,this.classifyData.innerCode);

        },
        handleError(e){
            if(this.statusType ==='Book'||this.statusType ===''){
                e.target.src = `${this.imageDomainNew}images/default1.png`
            }else if(this.statusType ==='AudioBook'||this.statusType==='audioBook'){
                e.target.src = `${this.imageDomainNew}images/default2.png`
            }else if(this.statusType ==='Course'||this.statusType==='course'){
                e.target.src = `${this.imageDomainNew}images/default2.png`
            }
            
        },
        //跳转·详情
        setupBackRouterPath(item){
            if(this.statusType==='Book'||this.statusType ===''){
                this.$router.push({
                    path: '/ebookdtl',
                    query: {
                        id: item.source.sourceBookInfoID,
                        token:this.token
                    }
                })
            }else if(this.statusType==='AudioBook'||this.statusType==='audioBook'){
                this.$router.push({
                    path: '/Audtl',
                    query: {
                        id: item.source.sourceID,
                        token:this.token
                    }
                })
            }else if(this.statusType==='Course'||this.statusType==='course'){
                this.$router.push({
                    path: '/couraudio',
                    query: {
                        id: item.source.sourceID,
                        token:this.token
                    }
                })
            }
            
        },
        // 1. 获取父组件的滚动容器DOM
        getParentScrollContainer() {
            this.scrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!this.scrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref或选择器');
                return;
            }
            // 监听父容器的滚动事件
            this.scrollContainer.addEventListener('scroll', this.handleParentScroll);
        },
        handleParentScroll() {
            // 防抖：300ms内只执行一次，避免频繁触发
            clearTimeout(this.scrollDebounce);
            this.scrollDebounce = setTimeout(() => {
                this.checkParentScrollBottom();
            }, 300);
        },
        checkParentScrollBottom() {
            if (!this.scrollContainer) return;
            const { scrollTop, clientHeight, scrollHeight } = this.scrollContainer;
            const threshold = 100;  // 距离底部200px时触发加载
            // 滚动到底部条件：当前滚动位置 + 容器高度 + 阈值 >= 内容总高度
            const isNearBottom = scrollTop + clientHeight + threshold >= scrollHeight;

            // 满足条件且非加载中、有更多数据，触发加载
            if (isNearBottom && !this.classifyData.loading  && !this.noMore) {
                this.classifyData.pageIndex ++
                this.getList(this.classifyData.code,this.classifyData.innerCode);
            }
            let scrollY = scrollTop;
            this.isShowScrollBtn = scrollY ;
        },
    }
}
</script>

<style lang="scss" scoped>
.maxBox {
    .showScrollBtn {
        display: block !important;
    }
    .top {
    width: 70px;
    height: 70px;
    background: #000000;
    border-radius: 8px;
    opacity: 0.19;
    display: flex;
    align-items: center;
    .divg {
      width: 32px;
      height: 18px;
      margin: 0 auto;
    }
  }
}
.ReadingClassify{
    
    .topbg {
        width: 100%;
        height: 200px; // 设置顶部背景高度
        margin: 0 auto;
        overflow: hidden; // 隐藏超出部分
        position: relative;
        background: url(../../assets/readimg/classify.png) no-repeat;
        background-size: 100% 100%;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover; // 保持图片比例，填充容器
            object-position: center; // 图片居中显示
        }
        .header-title{
            max-width: 1200px;
            color: white;
            font-size: 32px;
            font-weight: bold;
            text-align: left;
            position: relative;
            margin: 0 auto;
            padding: 80px 20px;
            padding-bottom: 0;
            &::after {
                content: "";
                position: absolute;
                bottom: 0px;
                left: 0;
                height: 1px;
                width: 8em;
                background-color: #fff;
                border-radius: 10px;
            }
        }

    }
    .ereas {
        width: 80%;
        max-width: 1200px;
        margin: 20px auto;
        display: flex;
        .left {
            width: 20%;
            background-color: #fff; // 左侧背景色
            padding: 20px 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            margin-right: 30px;
        }
        .right {
            width: 80%;
            position: relative;
            .type {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .voice {
                    position: relative;
                    display: inline-block;
                    margin-right: 30px;
                    z-index: 1;
                    background: none;
                    border: none;
                    padding: 0;
                    font: inherit;
                    color: inherit;
                    cursor: pointer;
                    font-weight: 500;
                    outline: none;
                    transition: all 0.3s ease;
                }
                
                .voice:hover {
                    opacity: 0.8;
                }
                
                .voice:focus {
                    outline: 2px solid #007bff;
                    outline-offset: 2px;
                }
                .voiceActive:before {
                    z-index: -1;
                    content: "";
                    position: absolute;
                    bottom: 0px;
                    left: -3px;
                    width: 100%;
                    height: 10px;
                    background: linear-gradient(to right, #FFC5BD, #fff);
                }
                .filter-button {
                    padding: 3px 20px;
                    border: none;
                    border-radius: 20px;
                    margin-right: 10px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    outline: none;
                    
                    // 默认状态（未选中）
                    background-color: #dddddd;
                    color: #666666;
                    
                    // 悬停效果（未选中时）
                    &:hover:not(.active) {
                        background-color: #cccccc;
                        color: #333333;
                    }
                    
                    // 选中状态
                    &.active {
                        background-color: #e6564e; // 红色背景
                        color: #ffffff; // 白色字体
                        
                        // 选中状态的悬停效果
                        &:hover {
                            background-color: #d44439; // 稍微深一点的红色
                        }
                    }
                    
                    // 点击效果
                    &:active {
                        transform: scale(0.98);
                    }
                }
                
                // 移除最后一个按钮的右边距
                .filter-button:last-child {
                    margin-right: 0;
                }
            }
            .book {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                margin-top: 30px;
                gap: 30px;
                .book-item {
                    display: flex;
                    background-color: #fff;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                    transition: all 0.3s ease;
                    overflow: hidden;
                    
                    &:hover {
                        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
                        transform: translateY(-2px);
                    }
                    
                    .lefts {
                        width: 35%;
                        min-height: 200px;
                        flex-shrink: 0;
                        position: relative;
                        overflow: hidden;
                        border-radius: 12px;
                        cursor: pointer;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            object-position: center;
                            display: block;
                            border-radius: 12px;
                        }
                    }
                    .right {
                        flex: 1;
                        padding: 12px 24px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        
                        .title {
                            font-size: 18px;
                            font-weight: 500;
                            color: #333;
                            // margin-bottom: 8px;
                            line-height: 1.4;
                            height: 2.8em;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            cursor: pointer;
                        }
                        
                        p {
                            font-size: 14px;
                            color: #666;
                            // margin-bottom: 12px;
                            font-weight: 400;
                            line-height: 1.4;
                            min-height: 2.8em;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        
                        .desc {
                            flex: 1;
                            font-size: 13px;
                            line-height: 1.6;
                            max-height: calc(6.4em + 14px); // 4行 × 1.6行高 = 6.4em，确保精确显示4行
                            color: #888;
                            background-color: #F7F7F7;
                            border-radius: 8px;
                            padding: 12px;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 4;
                            -webkit-box-orient: vertical;
                            
                            // 重置内部p标签的样式，避免文字重叠
                            :deep(p) {
                                margin: 0;
                                padding: 0;
                                font-size: inherit;
                                line-height: inherit;
                                color: inherit;
                            }
                        }
                    }
                }
            }
        }
    }

}
// 无更多数据样式
.no-more {
    padding: 15px;
    text-align: center;
    color: #aeaeae;
    font-size: 14px;
    position: absolute;
    bottom:-7px;
    left:50%
}
.no-data{
        color: #aeaeae;
        position: absolute;
        top:10%;
        left:50%
    }
</style>